<template>
    <div class="file-download">
        <div class="text text-secondary text-file">{{file.label}}</div>
        <div class="icon-file" :style="{marginRight : marginRightIcon}">
            <a :href="file.path ? file.path : '#!'" target="_blank"><icon-download /></a>
        </div>
    </div>
</template>

<script>
import IconDownload from '@/components/Icons/Download.vue'

export default {
    name: 'file-download',
    props: ['file', 'marginRightIcon'],
    components: {
        IconDownload
    }
}
</script>
